import React from "react";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";

import { formatCurrency } from "../../../utils/helpers";
import useVacacionesPendientes from "./Hooks/useVacacionesPendientes";
import Modal from "../../general/Modal";
import Select from "react-select";

dayjs.extend(duration);
dayjs.extend(relativeTime);

const VacacionesPendientes = () => {
    const {
        empleados,
        onChangeOrden,
        sucursal,
        totalPagar,
        totalRedondeado,
        toggleTXTBR,
        cuentas,
        cuentaTXTBR,
        showTXTBR,
        setCuentaTXTBR,
        generarTXTBR
    } = useVacacionesPendientes();

    return (
        <>
            <style>{`@page {size: 11in  8.5in;} *{font-size: 14px}`}</style>
            <div className="ordernar-resultados no-print">
                <div className="form-group d-flex align-items-center">
                    <div className="radio-btn">
                        <label>
                            <input type="radio" onChange={onChangeOrden} name="orden" value="nombre" defaultChecked={true} /> Ordenar por Nombre
                        </label>
                        <label>
                            <input type="radio" onChange={onChangeOrden} name="orden" value="codigo" /> Ordenar por Código
                        </label>
                    </div>
                    <button className="btn btn-secondary" onClick={toggleTXTBR}>Generar TXT BR</button>
                </div>
            </div>
            <div className='row'>
                <h2 className='col-md-12 text-center m-b-5'>
                    Vacaciones Pendientes {dayjs().endOf('year').format('YYYY')}
                </h2>
                <div className='col-md-12 text-center'>
                    {sucursal.nombre} - {sucursal.direccion} •{" "}
                    {new Date().toLocaleString()}
                </div>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL EMPLEADOS: {empleados.length}
                    </div>

                    <div className='float-right'>
                        <h3>Total: {formatCurrency(totalPagar)}</h3>
                    </div>
                </div>
            </div>
            <table className='table m-b-40'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nombre</th>
                        <th>Tiempo</th>
                        <th>Tipo</th>
                        <th>Cédula</th>
                        <th>Cuenta</th>
                        <th>Banco</th>
                        <th>Días</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {empleados.map((empleado, index) => {
                        return (
                            <tr key={empleado.id}>
                                <td>{index+1}</td>
                                <td>
                                    {empleado.nombre} {empleado.apellido}
                                    <div><small>{empleado.codigo}</small></div>
                                </td>
                                <td>{empleado.anios} años</td>
                                <td>
                                    {empleado.tipo?.nombre}
                                    <div><small>Sueldo: {formatCurrency(empleado.sueldo)}</small></div>
                                </td>
                                <td>{empleado.cedula}</td>
                                <td>{empleado.cuenta_bancaria}</td>
                                <td>{empleado.institucion_financiera}</td>
                                <td>{empleado.anios < 5 ? 14 : 18}</td>
                                <td>{formatCurrency(empleado.montoPagar)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className='row'>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL EMPLEADOS: {empleados.length}
                    </div>

                    <div className='float-right'>
                        <h3>Total: {formatCurrency(totalPagar)}</h3>
                    </div>
                </div>
            </div>

            <Modal
                toggle={toggleTXTBR}
                title='Generar TXT BR'
                acceptText='Generar'
                callback={generarTXTBR}
                show={showTXTBR}>
                <div className="m-b-60">
                    Cuenta:
                    <div>
                        <Select
                            value={cuentaTXTBR}
                            onChange={(e) => setCuentaTXTBR(e)}
                            menuPosition="fixed"
                            options={cuentas.map(c => ({label: c.nombre, value: c.id}))}
                            />
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default VacacionesPendientes;
